import React from "react";
import PropTypes from "prop-types";
/* Components */
import Parameter from "../CommonForBoth/Parameter";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Card } from "semantic-ui-react";
/* i18n */
import { withTranslation } from "react-i18next";
/* Helpers */
import { etherscanLink } from "@/helpers/ensuro_helper";
import { ZERO_ADDRESS } from "@/helpers/cooler_helper";
import { formatSecondsToDaysValue } from "@/helpers/date_helper";
import { links } from "@/config";
/* Store */
import colors from "@/colors";

const ETokenParams = ({
  t,
  pas,
  address,
  internalLoanInterestRate,
  minUR,
  maxUR,
  yieldVaultAddress,
  yieldVaultName,
  cooldownPeriod,
  hasValidCooler,
  wrapper,
  weTokenRate,
  etkSymbol,
}) => {
  const isImmediate = !hasValidCooler || formatSecondsToDaysValue(cooldownPeriod?.value) === 0;
  const weTokenRateStr = weTokenRate?.value != null ? Number(weTokenRate.value).toFixed(4) : "";
  return (
    <Card fluid className="params">
      <a target="_blank" className="right-aligned" rel="noopener noreferrer" href={etherscanLink(address)}>
        <p className="font-size-14">
          {t("ViewContractInBlockExplorer")} <i className="uil uil-external-link-alt" />
        </p>
      </a>
      <br />

      {wrapper && (
        <>
          <Parameter
            name={t("Wrapper")}
            value={{
              state: weTokenRate,
              link: {
                linkedTo: etherscanLink(wrapper.address),
                str: `1 ${etkSymbol} = ${weTokenRateStr} ${wrapper.symbol}`,
              },
            }}
            renderType="link"
          />
          <hr style={{ width: "90%", color: colors.secondary, marginTop: "0" }} />
        </>
      )}

      <Parameter
        name={t("Withdrawal cooldown")}
        value={
          isImmediate
            ? { state: "LOADED", value: t("Immediate") }
            : { ...cooldownPeriod, value: formatSecondsToDaysValue(cooldownPeriod?.value) }
        }
        renderType={isImmediate ? "string" : "number"}
        suffix={isImmediate ? "" : " days"}
        options={{ maximumFractionDigits: 2 }}
      />
      <hr style={{ width: "90%", color: colors.secondary, marginTop: "0" }} />

      {yieldVaultAddress && yieldVaultAddress !== ZERO_ADDRESS && (
        <>
          <Parameter
            name={t("Yield Vault")}
            value={{
              state: yieldVaultName,
              link: {
                linkedTo: links.assets,
                str: t("Check allocation"),
              },
            }}
            renderType="link"
          />
          <hr style={{ width: "90%", color: colors.secondary, marginTop: "0" }} />
        </>
      )}

      <Parameter
        name={t("Pool Loan Interest Rate")}
        value={internalLoanInterestRate}
        suffix={"%"}
        percentage={true}
        options={{ maximumFractionDigits: 2, notation: "standard" }}
      />
      <hr style={{ width: "90%", color: colors.secondary, marginTop: "0" }} />
      <Parameter
        name={t("Min Utilization Rate")}
        value={minUR}
        suffix={"%"}
        percentage={true}
        options={{ maximumFractionDigits: 2, notation: "standard" }}
      />
      <hr style={{ width: "90%", color: colors.secondary, marginTop: "0" }} />

      <Parameter
        name={t("Max Utilization Rate")}
        value={maxUR}
        suffix={"%"}
        percentage={true}
        options={{ maximumFractionDigits: 2, notation: "standard" }}
      />

      {pas && (
        <>
          <hr style={{ width: "90%", color: colors.secondary, marginTop: "0" }} />
          <Row>
            <Col md={5} xs={6}>
              <p>
                <strong>{t("Risk Partners")}</strong>
              </p>
            </Col>
            {pas.map((pa, idx) => (
              <React.Fragment key={idx}>
                <Col md={7} xs={6} className="params-value params-col">
                  <Link to={`/portfolios/${pa.address}`}>
                    <p>{pa.name}</p>
                  </Link>
                </Col>
                <Col md={5} xs={6}></Col>
              </React.Fragment>
            ))}
          </Row>
        </>
      )}
    </Card>
  );
};

ETokenParams.propTypes = {
  t: PropTypes.any,
  yieldVaultAddress: PropTypes.string,
  yieldVaultName: PropTypes.shape({ state: PropTypes.string, value: PropTypes.any }),
  cooldownPeriod: PropTypes.shape({ state: PropTypes.string, value: PropTypes.any }),
  wrapper: PropTypes.shape({
    address: PropTypes.string,
    symbol: PropTypes.string,
    name: PropTypes.string,
  }),
  weTokenRate: PropTypes.shape({ state: PropTypes.string, value: PropTypes.any }),
  etkSymbol: PropTypes.string,
};

export default withTranslation()(ETokenParams);
